export const DEFAULT_THEME = 'system';
export const DEFAULT_LIGHT_THEME = 'light';
export const DEFAULT_DARK_THEME = 'dark';

export const LIGHT_THEMES = ['light', 'light-hc'];
export const DARK_THEMES = ['dark', 'dark-hc'];
export const THEMES = [...LIGHT_THEMES, ...DARK_THEMES];

export const ROOT_CLASSNAME = 'root';

export const DEFAULT_DIRECTION = 'ltr';
